import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-wr"
}
const _hoisted_2 = {
  key: 1,
  class: "title-main"
}
const _hoisted_3 = { class: "title-buttons-wr" }
const _hoisted_4 = {
  key: 0,
  class: "card"
}
const _hoisted_5 = { class: "custom-terms-card" }
const _hoisted_6 = { class: "card-title-toggle custom-terms-title" }
const _hoisted_7 = { class: "toggle-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "custom-terms-body"
}
const _hoisted_9 = { class: "input-row" }
const _hoisted_10 = { class: "input-wr" }
const _hoisted_11 = { class: "input-row" }
const _hoisted_12 = { class: "toggle-block" }
const _hoisted_13 = { class: "aml-information-card" }
const _hoisted_14 = { class: "card-title-toggle" }
const _hoisted_15 = { class: "toggle-wrapper" }
const _hoisted_16 = {
  key: 0,
  class: "card-title-toggle"
}
const _hoisted_17 = { class: "title-wrapper" }
const _hoisted_18 = { class: "card-title-bold title" }
const _hoisted_19 = {
  key: 0,
  class: "toggle-wrapper"
}
const _hoisted_20 = { class: "form-wrapper" }
const _hoisted_21 = { class: "block-wrapper" }
const _hoisted_22 = { class: "actions-wrapper" }
const _hoisted_23 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["title-main-wr", { 'preview-center': $setup.isPreviewActive }])
        }, [
          ($setup.isPreviewActive)
            ? (_openBlock(), _createBlock($setup["EOIRequestForm"], {
                key: 0,
                estateId: $setup.estateId,
                eoiTemplate: $setup.form,
                isPreview: true
              }, null, 8, ["estateId", "eoiTemplate"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, "Edit Form Fields")),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "button default white-bg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isPreviewActive = !$setup.isPreviewActive))
            }, _toDisplayString(!$setup.isPreviewActive ? "Preview" : "Exit Preview"), 1),
            (!$setup.isPreviewActive)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "button default primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.save()))
                }, "Save & Publish"))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (!$setup.isPreviewActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title-wrapper" }, [
                    _createElementVNode("div", { class: "card-title-bold title" }, "Custom terms")
                  ], -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode($setup["ToggleButton"], {
                      additionalClass: 'large',
                      modelValue: $setup.customTermsEnabled,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.customTermsEnabled) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                ($setup.customTermsEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("form", {
                        class: "default-form",
                        onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "Custom terms", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              class: "input custom-terms-textarea",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.customTermsForm.text) = $event)),
                              placeholder: "Enter custom terms"
                            }, null, 512), [
                              [
                                _vModelText,
                                $setup.customTermsForm.text,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode($setup["ToggleButton"], {
                              modelValue: $setup.customTermsForm.showOnlyCustomTerms,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.customTermsForm.showOnlyCustomTerms) = $event)),
                              additionalClass: 'large',
                              labelBold: 'toggle-title-font',
                              label: "Show only custom terms"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ], 32)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "title-wrapper" }, [
                    _createElementVNode("div", { class: "card-title-bold title" }, "Request AML Information")
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode($setup["ToggleButton"], {
                      additionalClass: 'large',
                      modelValue: $setup.form.requestAmlInformation,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.requestAmlInformation) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getGroups, (group, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "card-wrapper",
                  key: index
                }, [
                  (group.groupName !== 'default_group')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString($setup.capitalizeString(group.groupName)), 1)
                        ]),
                        (!group.isRequired)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode($setup["ToggleButton"], {
                                additionalClass: 'large',
                                modelValue: group.isSelectedFields,
                                "onUpdate:modelValue": ($event: any) => ((group.isSelectedFields) = $event),
                                onChange: ($event: any) => ($setup.switchToggle(group.isSelectedFields, index))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("form", {
                      class: "default-form form",
                      onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.fields, (field) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createVNode($setup["CheckboxInput"], {
                            label: $setup.checkboxLabelText(field.fieldName),
                            modelValue: field.isRequired ? true : field.isActive,
                            disabled: field.isRequired,
                            class: _normalizeClass($setup.getCheckboxClasses(field.fieldName)),
                            "onUpdate:modelValue": ($event: any) => ((field.isActive = !field.isActive), $setup.checkIsSelectedFields(group))
                          }, null, 8, ["label", "modelValue", "disabled", "class", "onUpdate:modelValue"])
                        ]))
                      }), 256))
                    ], 32)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", {
                  class: "button default",
                  onClick: $setup.setDefaultTemplate
                }, "Set as Default"),
                _createElementVNode("div", {
                  class: "button default",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.router.push({ name: 'EOI' })))
                }, "Cancel")
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23))
      : _createCommentVNode("", true)
}